<template>
  <div class="news-detail">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <router-link to="/">{{ $t(`page.index.navTitle`) }}</router-link>
      <span class="separator">></span>
      <router-link to="/news">{{ $t("page.news.navTitle") }}</router-link>
    </div>

    <div class="content-wrapper">
      <!-- 标题 -->
      <h1 class="title">{{ newsDetail.name }}</h1>

      <!-- 文章信息 -->
      <div class="article-info">
        <span class="date">{{ formatDate(newsDetail.addtime) }}</span>
        <span class="views">{{ newsDetail.hit }}</span>
      </div>

      <!-- 文章内容 -->
      <div class="article-content" v-html="newsDetail.content"></div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
export default {
  name: "NewsDetail",
  data() {
    return {
      newsDetail: {
        id: "",
        title: "",
        content: "",
        created_at: "",
        views: 0,
      },
    };
  },
  created() {
    this.getNewsDetail();
  },
  watch: {
    $route() {
      this.getNewsDetail();
    },
  },
  methods: {
    async getNewsDetail() {
      try {
        const id = this.$route.params.id;
        const res = await this.$axios.post(`/api/index/getNewsDetail`, {
          language: Cookies.get("locale"),
          id: id
        });
        this.newsDetail = res.data
      } catch (error) {
        console.error("获取新闻详情失败:", error);
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(date.getDate()).padStart(2, "0")}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.news-detail {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  min-height: 100vh;

  .breadcrumb {
    margin-bottom: 30px;
    font-size: 14px;
    color: #666;

    a {
      color: #666;
      text-decoration: none;

      &:hover {
        color: #e93323;
      }
    }

    .separator {
      margin: 0 8px;
    }
  }

  .content-wrapper {
    background-color: #fff;
    padding: 40px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    .title {
      font-size: 32px;
      font-weight: bold;
      color: #333;
      line-height: 1.4;
      margin-bottom: 20px;
      text-align: center;
    }

    .article-info {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 40px;
      padding-bottom: 20px;
      border-bottom: 1px solid #eee;
      font-size: 14px;
      color: #999;

      .date {
        margin-right: 20px;

        &::before {
          content: "📅 ";
        }
      }

      .views {
        &::before {
          content: "👁 ";
        }
      }
    }

    .article-content {
      font-size: 16px;
      line-height: 1.8;
      color: #333;

      :deep(p) {
        margin-bottom: 20px;
        text-indent: 2em;
      }

      :deep(h3) {
        font-size: 20px;
        font-weight: bold;
        color: #333;
        margin: 30px 0 15px 0;
        padding-left: 10px;
        border-left: 4px solid #e93323;
      }

      :deep(img) {
        max-width: 100%;
        height: auto;
        display: block;
        margin: 30px auto;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .news-detail {
    padding: 10px;

    .content-wrapper {
      padding: 20px;

      .title {
        font-size: 24px;
      }

      .article-content {
        font-size: 14px;

        :deep(p) {
          text-indent: 1.5em;
        }
      }
    }
  }
}
</style>
